import React from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

import { CommonInputProps, FormInputWrapper } from './FormInputInternals';
import { Input } from './Input';

interface FormPhoneNumberInputProps extends Omit<PatternFormatProps, 'name' | 'format'>, CommonInputProps {
    placeholder?: string;
    optional?: boolean;
}

export const FormPhoneNumberInput = ({
    name,
    label,
    description,
    vertical,
    placeholder,
    optional,
    disabled,
    onBlur: onCustomBlur,
    onFocus: onCustomFocus,
    ...numberFormatProps
}: FormPhoneNumberInputProps) => {
    return (
        <FormInputWrapper
            {...{ name, label, description, vertical, disabled }}
            fieldRenderer={({ field: { onChange, value, onBlur } }) => (
                <PatternFormat
                    {...numberFormatProps}
                    id={name}
                    placeholder={placeholder}
                    valueIsNumericString
                    onValueChange={(v) => onChange(v.value)}
                    value={value}
                    customInput={Input}
                    format="+1 (###) ###-####"
                    mask="_"
                    $optional={optional}
                    disabled={disabled}
                    onBlur={(ev: React.FocusEvent<HTMLInputElement>) => {
                        onCustomBlur ? onCustomBlur?.(ev) : onBlur();
                    }}
                    onFocus={(ev: React.FocusEvent<HTMLInputElement>) => {
                        onCustomFocus?.(ev);
                    }}
                />
            )}
        />
    );
};
